import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConfigsLoaderService } from './config-loader.service';
import { ComplaintFilter, ComplaintList, ComplaintReportFilterDto, ComplaintsPaged, FlatComplaintFilterDto, ReportComplaintPaged, ReportRequestPagedDto } from 'app/models/complaints/complaint-list.model';
import {AddComment, Comments, ComplaintDetail, ComplaintLevel, ComplaintRejected, ComplaintSave} from 'app/models/complaints/complaint.interface';

@Injectable({
    providedIn: 'root'
})

export class ComplaintService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getPaged(filter: ComplaintFilter): Observable<ComplaintsPaged> {
        return this.httpClient.post<ComplaintsPaged>(`${this.apiEndpoint}/Complaint/getPaged`, filter);
    }

    getComplaintById(id: number): Observable<ComplaintDetail>{
        return this.httpClient.get<ComplaintDetail>(`${this.apiEndpoint}/Complaint/Get/${id}`);
    }

    getComplaintTypes(): Observable<ComplaintLevel[]> {
        return this.httpClient.get<ComplaintLevel[]>(`${this.apiEndpoint}/Complaint/GetTypes`);
      }

    addComment(data: AddComment): Observable<Comments>{
        return this.httpClient.post<Comments>(`${this.apiEndpoint}/Complaint/AddComment`, data);
    }
    saveComplaint(data: ComplaintSave): Observable<void> {
        return this.httpClient.post<void>(`${this.apiEndpoint}/Complaint/SaveComplaint`, data);
    }

    generateAlert(data: ComplaintSave): Observable<ComplaintSave>{
        return this.httpClient.post<ComplaintSave>(`${this.apiEndpoint}/Complaint/GenerateAlert`, data);
    }

    rejectComplaint(complaintRejected: ComplaintRejected): Observable<ComplaintRejected>{
        return this.httpClient.post<ComplaintRejected>(`${this.apiEndpoint}/Complaint/RejectComplaint`, complaintRejected);
    }

    changeToInClassification(id: number): Observable<void> {
        return this.httpClient.post<void>(`${this.apiEndpoint}/Complaint/ChangeToInClassification?complaintId=${id}`, null);
    }

    getComplaintComments(complaintId: number) {
        return this.httpClient.get<Comments[]>(`${this.apiEndpoint}/Complaint/GetComments/${complaintId}`);
    }

    generateReportComplaint(generateReportFilter: ComplaintReportFilterDto): Observable<any> {
        return this.httpClient.post<any>(`${this.apiEndpoint}/Complaint/GenerateReport`, generateReportFilter);
    }

    getReportPaged(filter: FlatComplaintFilterDto): Observable<ReportComplaintPaged>{
        return this.httpClient.post<ReportComplaintPaged>(`${this.apiEndpoint}/Report/RequestComplaintReport`, filter)
    }

    getDetailReports(data: ReportRequestPagedDto ): Observable<ReportComplaintPaged>{
        return this.httpClient.post<ReportComplaintPaged>(`${this.apiEndpoint}/Report/GetDetail`, data)
    }

    backToResquestReport(id: number){
        return this.httpClient.post(`${this.apiEndpoint}/Report/BackToRequestReport/${id}`, id)
    }

    deleteFlatReport(id: number){
        return this.httpClient.post<void>(`${this.apiEndpoint}/Report/DeletedRequestReport/${id}`, id);
    }
}
